<template>
    <div>
        定制后台
        <div class="biaoqian">上传位置</div>
        <div >
            <el-radio v-model="up_dz" label="image/dingzhitupian/主图/" border size="small">主图</el-radio>
            <el-radio v-model="up_dz" label="image/dingzhitupian/music/" border size="small">音乐</el-radio>
            <el-radio v-model="up_dz" label="image/dingzhitupian/1/" border size="small">图层1</el-radio>
            <el-radio v-model="up_dz" label="image/dingzhitupian/2/" border size="small">图层2</el-radio>
            <el-radio v-model="up_dz" label="image/dingzhitupian/3/" border size="small">图层3</el-radio>
            <el-radio v-model="up_dz" label="image/dingzhitupian/4/" border size="small">图层4</el-radio>
        </div>
        
        <div v-if="up_dz">
            <div class="biaoqian">文件图片</div>
            <el-upload class="upload-demo" action="#" multiple :http-request="param => upload_kt(param, 1)"
                :before-upload="upload_fast" :on-preview="file_list_fc" :file-list="videoFileList_kt"
                accept=".jpg,.png,.jpge,.mp4,.mov,.mp3">
                <el-button size="small" type="primary">点击上传</el-button>

                <div slot="tip" class="el-upload__tip">只能上传图片文件，且不超过5mb</div>
            </el-upload>
            <div style="margin-top: 10px;">
                <el-button size="small" type="danger" @click="qk">清空文件</el-button>
            </div>

        </div>
    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            dev: false,
            videoFileList_kt: [],
            videoFileList_cl: [],
            videoFileList_music: [],
            up_dz:''
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        upload_fast(file) {
            const isJPG = file.type === 'image/mp4';
            const isLt2M = file.size / 1024 / 1024 < 5;

            // if (!isJPG) {
            //     this.$message.error('上传视频文件只能是 mp4 格式!');
            // }
            if (!isLt2M) {
                this.$message.error('上传大小不能超过 5MB!');
            }
            return isLt2M
            return isJPG && isLt2M;

        },
        upload_music(file) {
            console.log(file)

            const isLt2M = file.size / 1024 / 1024 < 10;

            if (!isLt2M) {
                this.$message.error('上传视频大小不能超过 10MB!');
            }
            return isLt2M;

        },
        upload_kt(param, type) {
            
            // console.log(param,type)
            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            param.name = param.file.name    //文件名
            this.videoFileList_kt.push(param)

            let fdata = new window.FormData();
            fdata.append('file', param.file)
            fdata.append('key', '11-9')
            fdata.append('dz',this.up_dz)
            this.$ajax_upload.post('https://bdown.kissxx.cn:7790/mn_up.php?type=' + type, fdata, {
                onUploadProgress: function (progressEvent) { // 处理上传进度事件
                    let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
                    param.percentage = percent;  //动态设置param的percentage
                    // console.info(percent)
                }
            }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
                //请求成功
                // console.log(response.data);
                if (response.data.indexOf('处理插入成功') !== false) {
                    param.status = 'success';  //上传成功后将status属性改成success
                    // this.$msg.success(param.file.name + '上传成功')
                } else {
                    param.status = 'failed';
                    param.message = '上传失败';
                }
            }).catch(function (error) {
                // 请求失败处理
                console.log(error);
                param.status = 'failed';
                param.message = '上传失败';
            });


        },
        qk() {
            this.$confirm('此操作将永久删除所有文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$ajax_upload.post('https://bdown.kissxx.cn:7790/scwj.php?dz=./'+this.up_dz, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    this.$msg.success('成功')

                })
            })

        },
        file_list_fc(file) {
            console.log(file)
        },
        handlePreview(e) {
            console.log(e)
        },
        get_developer() {

            this.$ajax.get('qhy/user/developer').then(res => {
                // console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    if (jg.developer == 1) {
                        this.dev = true
                        return
                    }
                }
                this.$alert('没有权限', '提示', {
                    confirmButtonText: '确定',
                    type: 'warning',
                    callback: action => {
                        this.$router.push('/user/index')
                    }
                })
            })
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.el-radio{
    margin-right: 0px;
    width: 80px;
    margin-top: 10px;
}
.el-radio.is-bordered+.el-radio.is-bordered{
    margin-left:0px
}
</style>


// WEBPACK FOOTER //
// src/components/User/Dingzhi.vue


// WEBPACK FOOTER //
// src/components/User/Dingzhi.vue